let language = {
    COUPON_CODE_LIMIT_QTY_TIP_1: "每个订单仅允许使用",
    COUPON_CODE_LIMIT_QTY_TIP_2: "张优惠券",
};

export { language }
